import dynamic from 'next/dynamic'
import { useCallback, useState } from 'react'
import type { LightboxExternalProps } from 'yet-another-react-lightbox'
const LightBox = dynamic(
  () => import('../components/Lightbox').then(m => m.LightBox),
  {
    ssr: false,
  }
)
export const useLightbox = () => {
  const [open, setOpen] = useState(false)
  const [index, setIndex] = useState(0)
  const [interactive, setInteractive] = useState(false)

  const openLightBox = useCallback((index: number) => {
    setOpen(true)
    setIndex(index)
    setInteractive(true)
  }, [])

  const renderLightBox = useCallback(
    (props?: LightboxExternalProps) =>
      interactive ? (
        <LightBox
          open={open}
          index={index}
          close={() => setOpen(false)}
          {...props}
        />
      ) : null,
    [open, interactive]
  )

  return { openLightBox, renderLightBox }
}
